jQuery(document).on('submit', 'form[data-confirm]', function (event) {
    let $form = $(this),
        message = $form.data('confirm'),
        confirmed = message && confirm(message);

    if (!confirmed) {
        event.preventDefault();
    }
})
